export { default } from './CategoryWatermark';
